import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { toInitials } from "../../utilities";
import { getUserListApi, deleteUserApi } from "../../services/UserService";
import AddUserModal from "./addUserModal";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { FiEdit2, FiTrash2, FiInfo } from "react-icons/fi";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
const Users = () => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const handleToggleAddModal = () => {
    if (addModal) {
      setSelectedUser(null);
    }
    setAddModal(!addModal);
  };

  const handleToggleDeleteModal = () => {
    if (deleteModal) {
      setSelectedUser(null);
    }
    setDeleteModal(!deleteModal);
  };

  const getData = () => {
    setLoading(true);
    getUserListApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteUser = () => {
    setDeleteLoading(true);
    deleteUserApi(selectedUser?.id)
      .then((res) => {
        toast.success("User deleted successfully");
        getData();
        handleToggleDeleteModal();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Failed to delete user"
        );
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [param]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterUserAdd = () => {
    handleToggleAddModal();
    getData();
  };

  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          <div>
            <button
              className="btn btn-primary px-2"
              onClick={handleToggleAddModal}
              style={{ padding: "0.45rem 0" }}
            >
              <MdAdd className="me-1" size="20" />
              Add User
            </button>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("name")}
                    style={{ cursor: "pointer" }}
                  >
                    User{renderSortIcon("name")}
                  </th>
                  <th
                    onClick={() => handleSort("mobile_number")}
                    style={{ cursor: "pointer" }}
                  >
                    Mobile Number{renderSortIcon("mobile_number")}
                  </th>
                  <th
                    onClick={() => handleSort("service_center_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Service Center{renderSortIcon("service_center_name")}
                  </th>
                  <th
                    onClick={() => handleSort("is_active")}
                    style={{ cursor: "pointer" }}
                  >
                    Status{renderSortIcon("is_active")}
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                          style={{
                            width: "35px",
                            height: "35px",
                            fontWeight: 500,
                            fontSize: "0.9rem",
                          }}
                        >
                          <span>{toInitials(item?.name)}</span>
                        </div>
                        <div>
                          <Link className="text-uppercase text-primary fw-bold d-block">
                            {item?.name}
                          </Link>
                          <Link className="small text-secondary d-block">
                            {item?.email || "-"}
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>{item?.mobile_number || "-"}</td>
                    <td>{item?.service_center_name || "-"}</td>
                    <td>
                      {item?.is_active ? (
                        <span className="badge text-bg-success-soft rounded-pill">
                          Active
                        </span>
                      ) : (
                        <span className="badge text-bg-danger-soft rounded-pill">
                          In Active
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex gap-1 align-self-start">
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelectedUser(item);
                            handleToggleAddModal();
                          }}
                        >
                          <FiEdit2 className="text-dark" size="12" />
                        </span>
                        <span
                          className="p-1 btn btn-outline-light ms-1"
                          onClick={() => {
                            setSelectedUser(item);
                            handleToggleDeleteModal();
                          }}
                        >
                          <FiTrash2 className="text-dark" size="12" />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <AddUserModal
        data={selectedUser}
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterUserAdd}
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteModal}
        onClose={handleToggleDeleteModal}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{selectedUser?.name}</strong>?
              This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDeleteModal}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleDeleteUser}
            disabled={deleteLoading}
          >
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Users;
